module.exports = __webpack_public_path__ + "img/img.5ce5631a.png";